import ContactServiceClass from "../../RainbowSdk/ContactService";
import LogService from "../../CommonSdk/LogService";

import * as SandBoxContactsActionsTypes from "./SandBoxContactsActionsTypes";
import SandBoxServerFetch from "../../Request/SandBoxServerFetch";

const LOG_TAG = "ACTIONS:SANDBOX_CONTACTS";
const ContactService = new ContactServiceClass(SandBoxServerFetch);

export const setUserContact = (user) => (dispatch) => {
    LogService.trace(LOG_TAG, "setUserContact");

    if (user?.lastAvatarUpdateDate) {
        user.avatar = ContactService.getAvatarUrl(user.id)
    }

    dispatch({
        type: SandBoxContactsActionsTypes.SANDBOX_CONTACTS_SET_USER,
        payload: {
            user: user
        }
    });
}

export const getUserContact = () => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "getUserContact");

    const userId = getState().sandBoxContacts.user?.id;
    return dispatch(getContactDataById(userId, "full"))
        .then((user) => {
            dispatch(setUserContact(user));
            return Promise.resolve(user);
        })
        .catch((errorPayload) => {
            LogService.error(LOG_TAG, "getUserContact", "Error", errorPayload);
            return Promise.reject(errorPayload);
        });

}

export const getContacts = (idList) => (dispatch) => {
    LogService.trace(LOG_TAG, "getContacts");

    const promiseArray = [];
    if (idList) {
        idList.map(id => promiseArray.push(ContactService.getContactDataById(id)));
    }
    return Promise.allSettled(promiseArray)
        .then(results => {
            LogService.info(LOG_TAG, "getContacts", "success");
            let contactList = [];
            results.forEach((response) => {
                if (response.status === "fulfilled") {
                    contactList.push(response.value);
                }
            });

            dispatch({
                type: SandBoxContactsActionsTypes.SANDBOX_CONTACTS_UPDATE,
                payload: {
                    contacts: contactList,
                }
            });

            return Promise.resolve();
        });
};

export const getContactDataById = (contactId, format) => (dispatch) => {
    LogService.trace(LOG_TAG, "getContactDataById");

    return ContactService.getContactDataById(contactId, format)
        .then(contact => {
            dispatch({
                type: SandBoxContactsActionsTypes.SANDBOX_CONTACTS_UPDATE,
                payload: {
                    contacts: [contact],
                }
            });
            return Promise.resolve(contact);
        })
        .catch(errorPayload => {
            LogService.error(LOG_TAG, "getContactDataById", "Error retreiving contact data", errorPayload);
            return Promise.reject(errorPayload);
        });
}

export const clearContacts = () => (dispatch) => {
    LogService.trace(LOG_TAG, "clearContacts");
    dispatch({
        type: SandBoxContactsActionsTypes.SANDBOX_CONTACTS_CLEAR,
    });
};

export const getMissingContactIdList = (idList) => (dispatch, getState) => {
    LogService.trace(LOG_TAG, "getContacts");

    const missingContactIdList = [];
    idList.map(id => {
        let foundIndex = [...getState().sandBoxContacts.contacts, getState().sandBoxContacts.user].findIndex(contact => contact?.id === id);
        if (foundIndex < 0) {
            missingContactIdList.push(id);
        };

    })
    return missingContactIdList;
};
